var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanVerifiedHotel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 39.739,
    viewBox: "0 0 37 39.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    transform: "translate(14378 9482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(-15180.686 -11357.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12815",
    "data-name": "Path 12815",
    d: "M811.83,1894.371a.261.261,0,0,0-.225,0l5.5-3.179a.373.373,0,0,1,.4.122l6.5,6.163a1.387,1.387,0,0,0,.284.217l-5.5,3.173a1.141,1.141,0,0,1-.278-.21l-6.311-5.989A1.712,1.712,0,0,0,811.83,1894.371Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12816",
    "data-name": "Path 12816",
    d: "M812.283,1894.329c.024.027.052.042.069.069l6.364,6.034c.023.026.051.052.075.078l4.947-2.86-6.44-6.11c-.061-.053-.089-.061-.1-.061l-4.917,2.85Zm6.5,6.849a.3.3,0,0,1-.154-.044,1.526,1.526,0,0,1-.341-.252l-6.371-6.05a.937.937,0,0,0-.211-.172v-.007l.029-.053v-.01l-.037.063a.282.282,0,0,1-.382-.14.317.317,0,0,1,.132-.408l5.5-3.173a.636.636,0,0,1,.764.157l6.5,6.17a.921.921,0,0,0,.218.165.321.321,0,0,1,.154.27.315.315,0,0,1-.147.27l-5.5,3.17A.323.323,0,0,1,818.783,1901.178Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12817",
    "data-name": "Path 12817",
    d: "M818.783,1900.875l5.5-3.181q6.561,3.78,13.109,7.572l-5.5,3.17Q825.332,1904.656,818.783,1900.875Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12818",
    "data-name": "Path 12818",
    d: "M819.4,1900.875l12.488,7.2,4.885-2.814-12.491-7.216-4.882,2.825Zm12.488,7.875a.369.369,0,0,1-.156-.044l-13.1-7.572a.3.3,0,0,1-.158-.259.306.306,0,0,1,.158-.27l5.5-3.181a.33.33,0,0,1,.311,0l13.108,7.569a.307.307,0,0,1,.147.273.324.324,0,0,1-.147.267l-5.5,3.173A.374.374,0,0,1,831.89,1908.75Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12819",
    "data-name": "Path 12819",
    d: "M831.89,1908.436l5.5-3.17a.836.836,0,0,1,.39.676v.66l-5.5,3.173v-.653A.846.846,0,0,0,831.89,1908.436Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12820",
    "data-name": "Path 12820",
    d: "M832.394,1908.507a1.142,1.142,0,0,1,.2.6v.139l4.883-2.824v-.479a.579.579,0,0,0-.12-.3l-4.965,2.869Zm-.113,1.571a.267.267,0,0,1-.146-.034.316.316,0,0,1-.158-.269v-.653a.55.55,0,0,0-.251-.424.287.287,0,0,1-.139-.262.3.3,0,0,1,.147-.26l5.5-3.183a.319.319,0,0,1,.322.01,1.152,1.152,0,0,1,.539.931v.668a.307.307,0,0,1-.156.262l-5.5,3.18A.3.3,0,0,1,832.281,1910.078Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12821",
    "data-name": "Path 12821",
    d: "M811.4,1895l.1-.463c.052-.233.277-.26.5-.042l6.494,6.162a2.234,2.234,0,0,0,.286.218l2.67,1.537,1.347.783,9.09,5.241a.879.879,0,0,1,.391.686v.653l-13.565-7.832Q815.064,1898.461,811.4,1895Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12822",
    "data-name": "Path 12822",
    d: "M811.735,1894.9l7.2,6.822,13.045,7.527v-.123a.539.539,0,0,0-.243-.416l-13.1-7.572a1.526,1.526,0,0,1-.341-.252l-6.492-6.169c-.008,0-.008-.008-.019-.008l-.042.191Zm20.546,15.182a.267.267,0,0,1-.146-.034l-13.569-7.839-7.378-6.99a.289.289,0,0,1-.089-.285l.1-.461a.536.536,0,0,1,.356-.409.656.656,0,0,1,.66.209l6.5,6.163a.956.956,0,0,0,.224.173l13.108,7.571a1.156,1.156,0,0,1,.548.946v.653a.323.323,0,0,1-.157.269A.3.3,0,0,1,832.281,1910.078Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12823",
    "data-name": "Path 12823",
    d: "M814.133,1899.292l4.545,2.625,11.45,6.616v.408a.644.644,0,0,1-1.053.608l-13.9-8.033a2.32,2.32,0,0,1-1.043-1.815Z",
    fill: "#66ceef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12824",
    "data-name": "Path 12824",
    d: "M814.447,1899.832a2.013,2.013,0,0,0,.886,1.425l13.9,8.023a.47.47,0,0,0,.436.07c.1-.052.154-.21.154-.409v-.235l-15.374-8.874Zm15.1,10.16a1.238,1.238,0,0,1-.616-.183l-13.9-8.022a2.617,2.617,0,0,1-1.208-2.086v-.409a.32.32,0,0,1,.157-.27.333.333,0,0,1,.3,0l16,9.241a.3.3,0,0,1,.158.27v.408a1.065,1.065,0,0,1-.462.946A.9.9,0,0,1,829.544,1909.992Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12825",
    "data-name": "Path 12825",
    d: "M818.716,1901.943l-6.364-3.675v-2.374Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12826",
    "data-name": "Path 12826",
    d: "M812.655,1898.084l3.964,2.287-3.964-3.757v1.47Zm6.061,4.163a.231.231,0,0,1-.15-.042l-6.372-3.678a.3.3,0,0,1-.154-.259v-2.374a.286.286,0,0,1,.191-.278.293.293,0,0,1,.33.06l6.371,6.042a.311.311,0,0,1,.035.409A.324.324,0,0,1,818.716,1902.247Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12827",
    "data-name": "Path 12827",
    d: "M811.526,1877.085a18.683,18.683,0,0,0-3.66,1.6c-6.5,3.752-6.5,9.838,0,13.592a17.346,17.346,0,0,0,2.434,1.163l9.342-16.825Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12828",
    "data-name": "Path 12828",
    d: "M811.586,1877.389a18.885,18.885,0,0,0-3.563,1.556c-3.042,1.764-4.729,4.085-4.729,6.537s1.679,4.771,4.729,6.527a17.472,17.472,0,0,0,2.138,1.043l8.944-16.1-7.519.435Zm-1.286,16.359a.561.561,0,0,1-.113-.018,18.593,18.593,0,0,1-2.475-1.182c-3.244-1.878-5.026-4.381-5.026-7.066s1.782-5.2,5.034-7.069a19.037,19.037,0,0,1,3.712-1.624.267.267,0,0,1,.076-.016l8.119-.461a.331.331,0,0,1,.277.147.315.315,0,0,1,.011.314l-9.345,16.818A.293.293,0,0,1,810.3,1893.748Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12829",
    "data-name": "Path 12829",
    d: "M818.749,1886.855v18.9a.529.529,0,0,0,.365.375,1.413,1.413,0,0,0,1.2-.071.5.5,0,0,0,.235-.3v-18.9a.419.419,0,0,1-.15.234,1.324,1.324,0,0,1-1.459.044A.445.445,0,0,1,818.749,1886.855Z",
    fill: "#66ceef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12830",
    "data-name": "Path 12830",
    d: "M819.053,1905.743c.019,0,.052.041.183.1a1.127,1.127,0,0,0,.92-.052c.079-.052.079-.079.087-.105l-.008-18.156a1.74,1.74,0,0,1-1.182,0v18.209Zm.589.79a1.8,1.8,0,0,1-.641-.122.853.853,0,0,1-.556-.591l-.011-18.965a.312.312,0,0,1,.282-.3.3.3,0,0,1,.327.243c.01.016.01.042.089.1a1.04,1.04,0,0,0,1.069-.034c.034-.034.034-.034.042-.061a.3.3,0,0,1,.329-.243.312.312,0,0,1,.281.3v18.9a.789.789,0,0,1-.367.558A1.634,1.634,0,0,1,819.642,1906.533Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12831",
    "data-name": "Path 12831",
    d: "M820.288,1886.438a1.383,1.383,0,0,0-1.279,0c-.357.2-.357.53,0,.739a1.439,1.439,0,0,0,1.279,0A.392.392,0,0,0,820.288,1886.438Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12832",
    "data-name": "Path 12832",
    d: "M819.642,1886.593a1.088,1.088,0,0,0-.484.1c-.086.052-.105.1-.105.1s.019.053.105.1a1.124,1.124,0,0,0,.971,0c.09-.052.114-.1.114-.1s-.024-.052-.114-.1a1.068,1.068,0,0,0-.487-.1Zm0,1.043a1.582,1.582,0,0,1-.788-.2.733.733,0,0,1-.42-.635.744.744,0,0,1,.42-.633,1.713,1.713,0,0,1,1.58,0,.687.687,0,0,1,.01,1.268A1.622,1.622,0,0,1,819.642,1887.636Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12833",
    "data-name": "Path 12833",
    d: "M831.422,1878.686c-6.5-3.757-17.045-3.765-23.556,0s-6.5,9.838,0,13.592,17.054,3.754,23.556,0S837.922,1882.438,831.422,1878.686Z",
    fill: "#66ceef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12834",
    "data-name": "Path 12834",
    d: "M819.642,1876.174a23.75,23.75,0,0,0-11.619,2.771c-3.042,1.764-4.729,4.085-4.729,6.537s1.679,4.771,4.729,6.527c6.406,3.7,16.836,3.7,23.25,0,3.041-1.756,4.721-4.077,4.721-6.527s-1.68-4.773-4.729-6.537a23.738,23.738,0,0,0-11.623-2.771Zm0,19.225a24.475,24.475,0,0,1-11.93-2.851c-3.244-1.878-5.026-4.381-5.026-7.066s1.782-5.2,5.034-7.069c6.57-3.8,17.278-3.8,23.856,0h0c3.244,1.879,5.033,4.384,5.033,7.069s-1.789,5.188-5.033,7.066A24.447,24.447,0,0,1,819.642,1895.4Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12835",
    "data-name": "Path 12835",
    d: "M803.564,1899.52a.27.27,0,0,0-.226,0l5.5-3.172a.359.359,0,0,1,.4.119l6.495,6.163a1.664,1.664,0,0,0,.285.217l-5.5,3.174a1.374,1.374,0,0,1-.286-.219l-6.3-5.978A1.8,1.8,0,0,0,803.564,1899.52Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12836",
    "data-name": "Path 12836",
    d: "M804.017,1899.483a.883.883,0,0,1,.068.06l6.364,6.043a.621.621,0,0,0,.076.07l4.947-2.854-6.441-6.109c-.059-.06-.086-.068-.1-.068l-4.918,2.858Zm6.5,6.841a.34.34,0,0,1-.157-.034,2.4,2.4,0,0,1-.338-.262l-6.361-6.042a1.006,1.006,0,0,0-.217-.181l.025-.06h0l-.025.06a.29.29,0,0,1-.391-.138.312.312,0,0,1,.128-.409l5.5-3.181a.647.647,0,0,1,.765.166l6.5,6.162a1.056,1.056,0,0,0,.215.172.3.3,0,0,1,.157.262.3.3,0,0,1-.157.268l-5.5,3.183A.278.278,0,0,1,810.517,1906.324Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12837",
    "data-name": "Path 12837",
    d: "M810.517,1906.021l5.5-3.174q6.545,3.78,13.108,7.561l-5.5,3.184Q817.066,1909.811,810.517,1906.021Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12838",
    "data-name": "Path 12838",
    d: "M811.135,1906.021l12.49,7.212,4.883-2.825-12.489-7.213-4.884,2.826Zm12.49,7.875a.283.283,0,0,1-.158-.045l-13.107-7.561a.314.314,0,0,1,0-.54l5.5-3.173a.316.316,0,0,1,.3,0l13.118,7.572a.3.3,0,0,1,.146.259.3.3,0,0,1-.146.27l-5.5,3.173A.275.275,0,0,1,823.625,1913.9Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12839",
    "data-name": "Path 12839",
    d: "M823.625,1913.592l5.5-3.184a.85.85,0,0,1,.39.687v.652l-5.5,3.184v-.663A.843.843,0,0,0,823.625,1913.592Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12840",
    "data-name": "Path 12840",
    d: "M824.131,1913.66a1.258,1.258,0,0,1,.2.6v.131l4.884-2.817v-.479a.579.579,0,0,0-.12-.3l-4.962,2.869Zm-.116,1.574a.278.278,0,0,1-.147-.044.306.306,0,0,1-.156-.259v-.663a.54.54,0,0,0-.252-.417.3.3,0,0,1-.139-.27.292.292,0,0,1,.146-.259l5.5-3.173a.31.31,0,0,1,.322,0,1.175,1.175,0,0,1,.539.93v.668a.323.323,0,0,1-.156.27l-5.5,3.173A.348.348,0,0,1,824.015,1915.234Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12841",
    "data-name": "Path 12841",
    d: "M803.129,1900.144l.1-.462c.045-.233.278-.251.506-.041l6.492,6.161a1.574,1.574,0,0,0,.286.219l2.67,1.537,1.347.783,9.091,5.251a.846.846,0,0,1,.39.676v.663l-13.566-7.842Q806.8,1903.624,803.129,1900.144Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12842",
    "data-name": "Path 12842",
    d: "M803.469,1900.039l7.2,6.833,13.048,7.519v-.123a.561.561,0,0,0-.245-.409l-13.107-7.569a2.016,2.016,0,0,1-.338-.262l-6.492-6.163c-.011-.008-.019-.008-.019-.015l-.042.189Zm20.546,15.2a.278.278,0,0,1-.147-.044l-13.568-7.831-7.378-6.988a.331.331,0,0,1-.1-.288l.1-.461a.509.509,0,0,1,.356-.406.657.657,0,0,1,.66.207l6.5,6.163a1.063,1.063,0,0,0,.215.164l13.118,7.572a1.18,1.18,0,0,1,.547.946v.663a.3.3,0,0,1-.156.259A.348.348,0,0,1,824.015,1915.234Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12843",
    "data-name": "Path 12843",
    d: "M805.859,1904.445l4.553,2.625,11.447,6.608v.409a.712.712,0,0,1-.3.676.733.733,0,0,1-.746-.069l-13.9-8.022a2.357,2.357,0,0,1-1.051-1.826Z",
    fill: "#66ceef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12844",
    "data-name": "Path 12844",
    d: "M806.181,1904.977a2.029,2.029,0,0,0,.885,1.426l13.9,8.022a.345.345,0,0,0,.59-.338v-.228l-15.374-8.882Zm15.1,10.169a1.225,1.225,0,0,1-.616-.182l-13.9-8.022a2.632,2.632,0,0,1-1.208-2.1v-.4a.305.305,0,0,1,.155-.267.322.322,0,0,1,.307,0l16,9.238a.3.3,0,0,1,.157.262v.409a1.055,1.055,0,0,1-.46.946A.839.839,0,0,1,821.278,1915.146Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12845",
    "data-name": "Path 12845",
    d: "M810.449,1907.089l-6.372-3.677v-2.363Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12846",
    "data-name": "Path 12846",
    d: "M804.392,1903.237l3.961,2.288-3.961-3.764v1.476Zm6.057,4.167a.3.3,0,0,1-.149-.045l-6.372-3.676a.311.311,0,0,1-.155-.27v-2.363a.313.313,0,0,1,.184-.288.339.339,0,0,1,.338.06l6.369,6.05a.3.3,0,0,1,.037.4A.309.309,0,0,1,810.449,1907.4Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12847",
    "data-name": "Path 12847",
    d: "M810.3,1893.441c6.746,2.644,17.575,2.314,23.268-2.685l-13.926-14.14Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12848",
    "data-name": "Path 12848",
    d: "M810.745,1893.28c6.553,2.422,16.747,2.137,22.372-2.539l-13.4-13.614-8.968,16.153Zm9.013,2.111a26.872,26.872,0,0,1-9.571-1.661.323.323,0,0,1-.173-.183.282.282,0,0,1,.016-.252l9.345-16.825a.315.315,0,0,1,.225-.158.319.319,0,0,1,.263.095l13.923,14.142a.274.274,0,0,1,.086.226.262.262,0,0,1-.1.217C830.274,1894.06,824.938,1895.391,819.758,1895.391Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12849",
    "data-name": "Path 12849",
    d: "M831.422,1878.686a22.275,22.275,0,0,0-8.667-2.654l-3.113.584,13.926,14.14C837.828,1887.029,837.1,1881.962,831.422,1878.686Z",
    fill: "#66ceef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12850",
    "data-name": "Path 12850",
    d: "M820.269,1876.815l13.307,13.517a6.441,6.441,0,0,0,2.392-5.371c-.226-2.251-1.9-4.389-4.7-6.016h0a22.069,22.069,0,0,0-8.491-2.6l-2.505.469Zm13.3,14.255a.3.3,0,0,1-.217-.1l-13.923-14.14a.3.3,0,0,1,.162-.514l3.112-.592a.193.193,0,0,1,.09,0,22.809,22.809,0,0,1,8.784,2.685h0c2.982,1.724,4.764,4.025,5,6.5a7.208,7.208,0,0,1-2.808,6.083A.287.287,0,0,1,833.568,1891.07Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12851",
    "data-name": "Path 12851",
    d: "M822.755,1876.032a27.594,27.594,0,0,0-11.229,1.053l1.113-.06,7-.409Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12852",
    "data-name": "Path 12852",
    d: "M819.59,1876.163a26.772,26.772,0,0,0-4.682.417l4.719-.268.731-.138c-.262-.011-.513-.011-.768-.011Zm-8.064,1.237a.312.312,0,0,1-.086-.611,27.992,27.992,0,0,1,11.352-1.061.312.312,0,0,1,.277.3.324.324,0,0,1-.254.315l-3.11.582-8.16.479Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12853",
    "data-name": "Path 12853",
    d: "M818.479,1876.538v1.26l.008.034a.644.644,0,0,0,.15.244,1.29,1.29,0,0,0,.625.295,1.809,1.809,0,0,0,1.164-.138.725.725,0,0,0,.357-.338.225.225,0,0,0,.018-.063l.008-.034v-1.26c-.008.026-.008.042-.019.071a.486.486,0,0,1-.086.154.946.946,0,0,1-.322.236,1.9,1.9,0,0,1-1.478,0,.835.835,0,0,1-.38-.331.673.673,0,0,1-.037-.1Z",
    fill: "#66ceef",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12854",
    "data-name": "Path 12854",
    d: "M818.791,1877.8c.01,0,.036.034.063.06a.887.887,0,0,0,.469.21,1.56,1.56,0,0,0,.965-.1.445.445,0,0,0,.209-.183v-.5a2.144,2.144,0,0,1-1.706,0v.514Zm.851.922a2.471,2.471,0,0,1-.442-.044,1.628,1.628,0,0,1-.773-.372.846.846,0,0,1-.235-.4.377.377,0,0,1-.016-.1v-1.26a.309.309,0,0,1,.277-.3.306.306,0,0,1,.33.245l.008.034a.5.5,0,0,0,.244.209,1.56,1.56,0,0,0,1.218,0,.6.6,0,0,0,.209-.157l.035.008v-.034h.146l-.138-.052a.306.306,0,0,1,.329-.253.31.31,0,0,1,.279.3v1.26c0,.026-.008.078-.008.1a.465.465,0,0,1-.045.12,1.029,1.029,0,0,1-.488.5A2.135,2.135,0,0,1,819.642,1878.72Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12855",
    "data-name": "Path 12855",
    d: "M820.47,1876a1.843,1.843,0,0,0-1.65,0,.506.506,0,0,0,0,.956,1.83,1.83,0,0,0,1.65,0C820.929,1876.695,820.929,1876.267,820.47,1876Z",
    fill: "#bdedf8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12856",
    "data-name": "Path 12856",
    d: "M819.642,1876.114a1.394,1.394,0,0,0-.668.153c-.139.079-.191.158-.191.211s.052.131.191.206a1.5,1.5,0,0,0,1.34,0c.138-.075.191-.154.191-.206s-.053-.132-.191-.211h0a1.378,1.378,0,0,0-.672-.153Zm0,1.346a2.033,2.033,0,0,1-.979-.236.882.882,0,0,1-.495-.746.868.868,0,0,1,.495-.74,2.143,2.143,0,0,1,1.962-.01v.01a.87.87,0,0,1,.495.74.9.9,0,0,1-.495.746A2.013,2.013,0,0,1,819.642,1877.46Z",
    fill: "#1a87c7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(-38.045 -28.016)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 3.663,
    cy: 3.655,
    rx: 3.663,
    ry: 3.655,
    transform: "translate(-14312.74 -9425.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M9.387,3.375A6.022,6.022,0,1,0,15.4,9.4,6.016,6.016,0,0,0,9.387,3.375Zm3.078,4.357L8.6,11.62h0a.522.522,0,0,1-.335.159.506.506,0,0,1-.338-.165L6.306,9.993a.115.115,0,0,1,0-.165l.514-.515a.112.112,0,0,1,.162,0L8.265,10.6,11.791,7.04a.114.114,0,0,1,.081-.035h0a.1.1,0,0,1,.081.035l.506.524A.114.114,0,0,1,12.465,7.732Z",
    transform: "translate(-14318.354 -9431.375)",
    fill: "#979aaa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanVerifiedHotel);
export default __webpack_public_path__ + "static/media/human-verified-hotel.8df375249907f89efa17caf5eee0941d.svg";
export { ForwardRef as ReactComponent };